/**
 * Defer Load
 */
function insertScripts(scripts, opt = {}) {
  scripts.forEach(scriptItem => {
    let append_flag = true;
    if (!window.location.href.includes('vego-garden-s-soil-cost-calculator') && scriptItem.includes('soil-calculator')) append_flag = false
    if (!window.location.href.includes('the-perfect-time-to-plant') && scriptItem.includes('time-to-plant')) append_flag = false
    if (!opt.need_subscription && scriptItem.includes('subscription')) append_flag = false
    if (!window.location.href.includes('giving-back') && !window.location.href.includes('school-gardens') && scriptItem.includes('giving-back')) append_flag = false
    if (!window.location.href.includes('help-me-choose') && scriptItem.includes('help-me-choose')) append_flag = false
    if (!window.location.href.includes('/products/') && (scriptItem.includes('vego-recent-viewed'))) append_flag = false
    if (!window.location.href.includes('/products/vego-garden-gift-card') && scriptItem.includes('calendar')) append_flag = false
    if (scriptItem && append_flag && !document.querySelector(`script[src="${scriptItem}"]`)) {
      let el = document.createElement('script')
      el.type = "text/javascript"
      el.src = scriptItem
      document.head.append(el)
    }
  })
}

function loadMobileMenuScript() {
  const attr = document.querySelector('.home-scripts')?.getAttribute('data-m-scripts')
  if (!attr) return
  insertScripts(
    attr.split(',').map((s) => s.trim()).filter((item) => item.indexOf('vego-mobile-menu') > -1),
    {}
  )
}

function initPage() {
  let thread_time = 5000
  let path_name = window.location.pathname
  let need_subscription = [`carbon-refill-kit`, `kitchen-composter`, `vegotabs`, `carbon-filter-refill-kit-vegotab-bundle`,`carbon-filter-refill-kit-vegotabs-bundle-copy`].find(item => window.location.href.includes(item))

  if (path_name != '/' && !path_name.includes('/products') && !path_name.includes('/collections')) thread_time = 500
  if (need_subscription) thread_time = 500
  if (path_name.includes('/help-me-choose')) thread_time = 500
  if (path_name.includes('/search')) thread_time = 800
  let speedScripts = []
  let scripts = document.querySelector('.home-scripts').getAttribute('data-scripts').split(',')
  let mobile_scripts = document.querySelector('.home-scripts').getAttribute('data-m-scripts').split(',')
  let scripts_tmp = []
  speedScripts = scripts.filter(script => {
    let is_in = [`vego-banner-term`].find(item => script.indexOf(item)>-1)
    if (!is_in) scripts_tmp.push(script)
    return is_in
  })

  scripts = scripts_tmp
  
  setTimeout(() => {
    insertScripts(speedScripts, {})
  },0)

  setTimeout(() => {
    insertScripts(scripts, { need_subscription })
    if (window.matchMedia('(max-width: 768px)').matches) {
      insertScripts(mobile_scripts, { need_subscription })
    }
  }, thread_time)

  // Align with hamburger CSS (.medium-up--hide @ 768) and mobileMenuController.
  const mobileMq = window.matchMedia('(max-width: 768px)')
  const onMobileMq = (e) => {
    if (e.matches) loadMobileMenuScript()
  }
  if (mobileMq.matches) loadMobileMenuScript()
  if (mobileMq.addEventListener) mobileMq.addEventListener('change', onMobileMq)
  else if (mobileMq.addListener) mobileMq.addListener(onMobileMq)
}
//
initPage()

window.addEventListener("load", function () {

  let rec_thread_other = window.innerWidth > 768 ? 1000 : 6000;

  function executeConsentScripts(marketingAllowed, analyticsAllowed) {
    // ---- [ Marketing ] ----
    if (marketingAllowed) {
      if (!window.__grin_loaded) {
        window.appendScript("https://d38xvr37kwwhcm.cloudfront.net/js/grin-sdk.js?shop=vego-gardening-store.myshopify.com");
        window.__grin_loaded = true;
      }
      if (!window.__retention_loaded) {
        window.appendScript("//cdn.shopify.com/proxy/b3b943ce714ac1958d6fb81f34c38f94112875110fc8db772c56d0604a3515ae/s3-us-west-2.amazonaws.com/jsstore/a/OO9H4O1/ge.js?shop=vego-gardening-store.myshopify.com&sp-cache-control=cHVibGljLCBtYXgtYWdlPTkwMA");
        window.appendScript("//cdn.shopify.com/proxy/8c42d01f5aac1566b97ba205bf9492ba34f852152beec46d80961f55c7967e01/app.retention.com/shopify/shopify_app_add_to_cart_script.js?shop=vego-gardening-store.myshopify.com&sp-cache-control=cHVibGljLCBtYXgtYWdlPTkwMA");
        window.__retention_loaded = true;
      }
      if (!window.__yotpo_loaded) {
        window.appendScript('https://cdn-widgetsrepository.yotpo.com/v1/loader/GMrPmOwmfbQQyiX96ovnXKEgiM2FIQCtCOEvofCf');
        window.__yotpo_loaded = true;
      }
      if (!window.__klaviyo_loaded) {
        window.appendScript('https://static.klaviyo.com/onsite/js/Uw3LDV/klaviyo.js?company_id=Uw3LDV');
        window.__klaviyo_loaded = true;
      }

      if (!window.__tolstoy_loaded && window.location.href.includes('/products/')) {
        const gotolstoy_url = "https://widget.gotolstoy.com/widget/widget.js?app-key=74d145e3-7c70-46d2-8af2-290e3eff51f0&shop=vego-gardening-store.myshopify.com";
        if (!document.querySelector(`[src="${gotolstoy_url}"]`)) {
          window.appendScript(gotolstoy_url);
          
          let gotolstoy_subscripe = document.querySelector(".page-product-v2");
          if (gotolstoy_subscripe && gotolstoy_subscripe.getAttribute("data-gotolsoy")) {
            setTimeout(() => {
              window.appendScript(gotolstoy_subscripe.getAttribute("data-gotolsoy"));
            }, 400);
          }
        }
        window.__tolstoy_loaded = true;
      }
      //console.log("✅ Marketing scripts loaded by Consent.");
    }

    // ---- [ Analytics ] ----
    if (analyticsAllowed && !window.__analytics_loaded) {
      window.appendScript("https://cdn.noibu.com/collect-core.js?shop=vego-gardening-store.myshopify.com");
      window.__analytics_loaded = true;
      //console.log("✅ Analytics script (Noibu) loaded by Consent.");
    }
  }

  // =====================================================================
  // Net 3: Advanced Polling Fallback (INDUSTRY BEST PRACTICE)
  // Eliminates "magic number" delays and minimizes data loss by checking
  // the API readiness every 200ms, up to a maximum of 3 seconds.
  // =====================================================================
  let checkAttempts = 0;
  const MAX_ATTEMPTS = 15; // 15 attempts * 200ms = 3000ms (3 seconds max)
  function pollConsentFallback() {
    // 1. Check if the Shopify Privacy API is fully loaded and ready
    if (typeof window.Shopify !== 'undefined' && window.Shopify.customerPrivacy) {

      let anyMarketingLoaded = window.__grin_loaded || window.__retention_loaded || window.__yotpo_loaded
        || window.__klaviyo_loaded || window.__tolstoy_loaded;
      
      // Attempt A: Use Granular Consent API (Shopify's modern standard)
      if (typeof window.Shopify.customerPrivacy.currentVisitorConsent === 'function') {
        const consentObj = window.Shopify.customerPrivacy.currentVisitorConsent();
        
        if (consentObj) {
          let isMarketingAllowed = consentObj.marketing !== 'no';
          let isAnalyticsAllowed = consentObj.analytics !== 'no';

          if ((anyMarketingLoaded && !isMarketingAllowed) || (window.__analytics_loaded && !isAnalyticsAllowed)) {
            console.warn("User revoked consent. Reloading page to kill trackers...");
            window.location.reload();
            return;
          }
          
          executeConsentScripts(isMarketingAllowed, isAnalyticsAllowed);
          return; // SUCCESS: Exit polling loop
        }
      } 
      // Attempt B: Legacy Binary Fallback (For older API versions)
      else if (typeof window.Shopify.customerPrivacy.getTrackingConsent === 'function') {
        const currentConsent = window.Shopify.customerPrivacy.getTrackingConsent();

        if (currentConsent === 'no' && (anyMarketingLoaded || window.__analytics_loaded)) {
          console.warn("User revoked consent. Reloading page to kill trackers...");
          window.location.reload();
          return;
        }
        if (currentConsent !== 'no') {
          executeConsentScripts(true, true);
        }
        return; // SUCCESS: Exit polling loop
      }
    }

    // 2. If API is not ready yet, keep polling until MAX_ATTEMPTS is reached
    checkAttempts++;
    if (checkAttempts < MAX_ATTEMPTS) {
      setTimeout(pollConsentFallback, 200); // Check again in 200ms
    } else {
      console.warn("Shopify Privacy API failed to initialize within 3 seconds. Fallback aborted.");
      executeConsentScripts(true, true);
    }
  }

  document.addEventListener("visitorConsentCollected", pollConsentFallback);
  window.addEventListener("PandectesEvent_OnConsent", pollConsentFallback);

  // Start the polling loop after the initial performance delay (rec_thread_other)
  setTimeout(pollConsentFallback, rec_thread_other + 1500);
  
})
